import { ProductSliderSources } from "@omni/types/components/product/enums/productSliderResource.enum";

import { ProductSlider } from "@/components/Product/ProductSlider/productSlider.container";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useProductPageContext } from "../../context/productPage.context";
import { ProductPageConfig } from "../../productPage.config";

export const RecentlyViewedProductSliderContainer = () => {
    const { t } = useGranite();
    const { product } = useProductPageContext();
    return (
        <ProductSlider
            title={t("sliders.recents.title")}
            source={ProductSliderSources.Recent}
            breakpointsConfig={{
                hidden: [],
                layoutSettings: ProductPageConfig.sliders.recent
            }}
            productTileConfig={{
                amountOfFeatures: 0,
                useInsidePadding: false,
                showButton: false,
                showCategoryLink: false,
                allowInstantAddToCart: false
            }}
            sku={product.sku}
        />
    );
};
